import { CpfCnsModel } from 'components/model-CpfCns'
import { TipoGrupoParticipanteAtividadeColetivaEnum } from 'graphql/types.generated'

import { CidadaoEditableTableModel } from './CidadaoEditableTable'

export const MSG_TIPO_GRUPO_REUNIAO_CIDADAOS_PARTICIPANTES =
  'Grupos do tipo reunião não podem ter cidadãos participantes.'

export const MSG_CIDADAO_JA_INCLUIDO = 'Cidadão informado já foi cadastrado.'

export const MSG_CIDADAO_SEM_CPF_CNS = 'CPF/CNS do cidadão é obrigatório para sua inclusão no grupo.'

export const MSG_EXCLUSAO_GRUPO_AC_MODAL =
  'Ao excluir, o grupo será removido e não poderá mais ser vinculado a registros de atividade coletiva. Esta ação é permanente e não poderá ser desfeita.'

export const MSG_INATIVACAO_GRUPO_AC_MODAL =
  'Ao ser inativado, o grupo será descontinuado e não poderá ser associado a registros de atividade coletiva. Caso necessário, o grupo poderá ser ativado novamente.'

export const MSG_ATIVACAO_GRUPO_AC_MODAL =
  'Ao ativar, o grupo ficará disponível novamente para ser associado a registros de atividade coletiva.'

export const isTipoGrupoReuniao = (tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum): boolean =>
  tipoGrupo === TipoGrupoParticipanteAtividadeColetivaEnum.REUNIAO

export const convertCidadaoEditableTableToCpfCns = (cidadaos: CidadaoEditableTableModel[]): CpfCnsModel[] =>
  cidadaos
    ?.map((item) => item.cidadao)
    .filter((cidadao) => !!cidadao?.cpf || !!cidadao?.cns)
    .map((cidadao) => ({ cpf: cidadao.cpf, cns: cidadao.cns })) ?? []
